import { parseQueryString } from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */
const searchBar = () => {
  (function ($) {
    const $elem = $('.js-search');
    const $input = $('.c-search-bar__input');
    const $searchResultText = $('.js-results-search-text');
    const $close = $('.js-search-close');
    const focusedClass = 'c-search-bar--focused';
    const desktopMediaQuery = '(min-width: 1024px)';

    // Sanitize user input to prevent XSS.
    function sanitizeInput(input) {
      return $('<div>').text(input).html();
    }

    // add 'what are you looking for?' placeholder text and open the search bar on desktop
    function openSearch() {
      if (!$elem.hasClass(focusedClass)) {
        const temp = $input.attr('placeholder');
        $input.attr('placeholder', $input.attr('data-alt'));
        $input.attr('data-alt', temp);
        $elem.addClass(focusedClass);
      }
    }

    // reset placeholder text and close the search bar on desktop
    function closeSearch() {
      if ($elem.hasClass(focusedClass)) {
        const temp = $input.attr('placeholder');
        $input.attr('placeholder', $input.attr('data-alt'));
        $input.attr('data-alt', temp);
        $input.val('');
        $elem.removeClass(focusedClass);
      }
    }

    // keep the current query in the search bar
    if (parseQueryString(window.location.search).query) {
      openSearch();
      // Decode the query string and sanitize it to prevent XSS.
      let value = decodeURIComponent(parseQueryString(window.location.search).query);
      let safeValue = sanitizeInput(value);
      $input.val(safeValue);
      // Use .text() instead of .html() to prevent XSS.
      $searchResultText.text(safeValue);
    }

    // user clicks on search bar
    $input.on('click', () => {
      openSearch();
    });

    // user clicks outside search bar on mobile
    $input.on('blur', () => {
      const isDesktop = window.matchMedia(desktopMediaQuery).matches;
      // reset search bar if nothing has been entered in the field
      if (!isDesktop && $input.val() === '') {
        closeSearch();
      }
    });

    // close the search bar on desktop when the user clicks the close button
    $close.on('click', () => {
      closeSearch();
    });

    // redirect to the results page when user makes a search
    $elem.on('submit', (e) => {
      e.preventDefault();
      // Encode the query string to prevent XSS.
      let userInput = $input.val().trim();
      if (userInput) {
        let safeInput = sanitizeInput(userInput);
        let safeQuery = encodeURIComponent(safeInput);
        window.location.href = `${window.location.origin}/search-results?query=${safeQuery}`;
      }
    });
  }(jQuery));
};

export default searchBar;
